import React from 'react'
import WhatsAppWidget from 'react-whatsapp-chat-widget'
import 'react-whatsapp-chat-widget/index.css'
import { Outlet, useLocation } from 'react-router-dom'

import Header from './components/general/Header'
import Footer from './components/general/Footer'
import logo from './assets/logo.png'

const GeneralPath = () => {
	const location = useLocation()

	return (
		<>
			<Header loc={location.pathname} />
			<div>
				<Outlet />
				<WhatsAppWidget
					phoneNo='2348166245118'
					position='right'
					widgetWidth='300px'
					widgetWidthMobile='260px'
					autoOpen={true}
					autoOpenTimer={5000}
					messageBox={true}
					messageBoxTxt='Hello... I want to make an enquiry.'
					iconSize='40'
					iconColor='white'
					iconBgColor='green'
					headerIcon={logo}
					headerIconColor='green'
					headerTxtColor='black'
					headerBgColor='green'
					headerTitle='John Doe'
					headerCaption='Online'
					bodyBgColor='#eee'
					chatPersonName='Showel Support'
					chatMessage={
						<>
							Hi there 👋
							<br /> How can I help you?
						</>
					}
					footerBgColor='#fff'
					btnBgColor='green'
					btnTxtColor='#fff'
					btnTxt='Start Chat'
				/>
			</div>
			<Footer />
		</>
	)
}

export default GeneralPath
